export default "__VITE_ASSET__DQhi1Ky5__"